import {
    IconAngleRight,
    IconBank,
    IconCreditCardFilled,
    IconFileText,
    IconPound
} from '@iwoca/icons';
import { Text } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { PREFERENCES_URL } from '../../constants';
import { DrawerContent } from '../drawerSlider/DrawerSlider';

export const QuickLinks = ({
    setDrawerContent
}: {
    setDrawerContent: (content: DrawerContent) => void;
}) => {
    return (
        <div className="w-full">
            <Text className="mb-m text-l font-bold">
                <FormattedMessage
                    id="_.credit_card.dashboard.quick_links"
                    defaultMessage="Manage my account"
                />
            </Text>

            <div className="flex flex-col gap-0 max-sm:px-l">
                {/* Make a payment */}
                <button
                    onClick={() => setDrawerContent('makePayment')}
                    className="w-full cursor-pointer border-0 bg-transparent p-0 text-left"
                >
                    <div className="flex w-full flex-row items-center justify-between border-b border-secondary-90 py-l hover:no-underline">
                        <div className="flex flex-row gap-m">
                            <IconPound className="fill-primary-10" />
                            <Text className="text-s font-med">
                                <FormattedMessage
                                    id="_.credit_card.dashboard.make_a_payment"
                                    defaultMessage="Make a payment"
                                />
                            </Text>
                        </div>
                        <IconAngleRight className="fill-primary-10" />
                    </div>
                </button>

                {/* Change payment details */}
                <Link to={{ pathname: '/company/' }}>
                    <div className="flex w-full flex-row items-center justify-between border-b border-secondary-90 py-l hover:no-underline">
                        <div className="flex flex-row gap-m">
                            <IconBank className="fill-primary-10" />
                            <Text className="text-s font-med">
                                <FormattedMessage
                                    id="_.credit_card.dashboard.change_payment_details"
                                    defaultMessage="Change payment details"
                                />
                            </Text>
                        </div>
                        <IconAngleRight className="fill-primary-10" />
                    </div>
                </Link>

                {/* Statements and documents */}
                <button
                    onClick={() => setDrawerContent('statementsAndDocuments')}
                    className="w-full cursor-pointer border-0 bg-transparent p-0 text-left"
                >
                    <div className="flex w-full flex-row items-center justify-between border-b border-secondary-90 py-l hover:no-underline">
                        <div className="flex flex-row gap-m">
                            <IconFileText className="fill-primary-10" />
                            <Text className="text-s font-med">
                                <FormattedMessage
                                    id="_.credit_card.dashboard.statements_and_documents"
                                    defaultMessage="Statements and documents"
                                />
                            </Text>
                        </div>
                        <IconAngleRight className="fill-primary-10" />
                    </div>
                </button>

                {/* Account preferences */}
                <Link to={{ pathname: PREFERENCES_URL }}>
                    <div className="flex w-full flex-row items-center justify-between border-b border-secondary-90 py-l hover:no-underline">
                        <div className="flex flex-row gap-m">
                            <IconCreditCardFilled className="my-auto fill-primary-10" />
                            <Text className="text-s font-med">
                                <FormattedMessage
                                    id="_.credit_card.dashboard.account_preferences"
                                    defaultMessage="Account preferences"
                                />
                            </Text>
                        </div>
                        <IconAngleRight className="fill-primary-10" />
                    </div>
                </Link>
            </div>
        </div>
    );
};
